// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "../Context/PaymentTypeContext.bs.js";

function updateArrayOfStringToOptionsTypeArrayWithUpperCaseLabel(arrayOfString) {
  return arrayOfString.map(item => ({
    value: item,
    label: item.toUpperCase()
  }));
}

function updateArrayOfStringToOptionsTypeArray(arrayOfString) {
  return arrayOfString.map(item => ({
    value: item
  }));
}

let defaultValue = {
  value: ""
};

function DropdownField(props) {
  let __width = props.width;
  let __className = props.className;
  let __disabled = props.disabled;
  let options = props.options;
  let __isLabelHidden = props.isLabelHidden;
  let fieldName = props.fieldName;
  let setDisplayValue = props.setDisplayValue;
  let displayValue = props.displayValue;
  let __isDisplayValueVisible = props.isDisplayValueVisible;
  let setValue = props.setValue;
  let value = props.value;
  let __isDisplayValueVisible_value = __isDisplayValueVisible !== undefined ? __isDisplayValueVisible : false;
  let __isLabelHidden_value = __isLabelHidden !== undefined ? __isLabelHidden : false;
  let __disabled_value = __disabled !== undefined ? __disabled : false;
  let __className_value = __className !== undefined ? __className : "";
  let __width_value = __width !== undefined ? __width : "w-full";
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let themeObj = match.themeObj;
  let config = match.config;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let dropdownRef = React.useRef(null);
  let match$2 = React.useState(() => false);
  let setInputFocused = match$2[1];
  let inputFocused = match$2[0];
  let match$3 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = match$3.parentURL;
  let iframeId = match$3.iframeId;
  let isSpacedInnerLayout = config.appearance.innerLayout === "Spaced";
  let elementType = CardThemeType$OrcaPaymentPage.getPaymentModeToString(PaymentTypeContext$OrcaPaymentPage.usePaymentType());
  let handleFocus = param => {
    setInputFocused(param => true);
    Utils$OrcaPaymentPage.handleOnFocusPostMessage(iframeId, elementType, parentURL);
  };
  let handleChange = ev => {
    let target = ev.target;
    let value = target.value;
    if (fieldName.length > 0) {
      LoggerUtils$OrcaPaymentPage.logInputChangeInfo(fieldName, loggerState);
    }
    setValue(param => value);
    if (!__isDisplayValueVisible_value) {
      return;
    }
    let findDisplayValue = Core__Option.getOr(options.find(ele => ele.value === value), defaultValue);
    if (setDisplayValue !== undefined) {
      return setDisplayValue(param => Core__Option.getOr(findDisplayValue.displayValue, value));
    }
  };
  let disbaledBG = React.useMemo(() => themeObj.colorBackground, [themeObj]);
  React.useEffect(() => {
    if (value === "" || !options.map(val => val.value).includes(value)) {
      setValue(param => Core__Option.getOr(options[0], defaultValue).value);
    }
  }, []);
  let focusClass = inputFocused || value.length > 0 ? `mb-7 pb-1 pt-2 ` + themeObj.fontSizeXs + ` transition-all ease-in duration-75` : "transition-all ease-in duration-75";
  let floatinglabelClass = inputFocused ? "Label--floating" : "Label--resting";
  let inputClassStyles = isSpacedInnerLayout ? "Input" : "Input-Compressed";
  let cursorClass = __disabled_value ? "cursor-not-allowed" : "cursor-pointer";
  return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
    condition: options.length > 0,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
          condition: !__isLabelHidden_value && fieldName.length > 0 && props.appearance.labels === "Above" && isSpacedInnerLayout,
          children: JsxRuntime.jsx("div", {
            children: fieldName,
            "aria-hidden": true,
            className: `Label `,
            style: {
              fontSize: themeObj.fontSizeLg,
              fontWeight: themeObj.fontWeightNormal,
              marginBottom: "5px",
              opacity: "0.6"
            }
          })
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
              condition: __isDisplayValueVisible_value && Core__Option.isSome(displayValue),
              children: JsxRuntime.jsx("div", {
                children: Core__Option.getOr(displayValue, ""),
                "aria-hidden": true,
                className: "absolute top-[2px] left-[2px] right-0 bottom-[2px]  pointer-events-none rounded-sm z-20 whitespace-nowrap",
                style: {
                  background: __disabled_value ? disbaledBG : themeObj.colorBackground,
                  opacity: __disabled_value ? "35%" : "",
                  padding: themeObj.spacingUnit,
                  width: "calc(100% - 22px)"
                }
              })
            }),
            JsxRuntime.jsx("select", {
              children: options.map((item, index) => JsxRuntime.jsx("option", {
                children: Core__Option.getOr(item.label, item.value),
                value: item.value
              }, index.toString())),
              ref: Primitive_option.some(dropdownRef),
              "aria-label": fieldName + ` option tab`,
              className: inputClassStyles + ` ` + __className_value + ` w-full appearance-none outline-none overflow-hidden whitespace-nowrap text-ellipsis ` + cursorClass,
              style: {
                background: __disabled_value ? disbaledBG : themeObj.colorBackground,
                opacity: __disabled_value ? "35%" : "",
                padding: themeObj.spacingUnit,
                paddingRight: "22px",
                width: "100%"
              },
              disabled: match$1.readOnly || __disabled_value,
              name: "",
              value: value,
              onFocus: handleFocus,
              onChange: handleChange
            }),
            JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
              condition: !__isLabelHidden_value && config.appearance.labels === "Floating",
              children: JsxRuntime.jsx("div", {
                children: fieldName,
                "aria-hidden": true,
                className: `Label ` + floatinglabelClass + ` absolute bottom-0 ml-3 ` + focusClass + ` pointer-events-none`,
                style: {
                  fontSize: inputFocused || value.length > 0 ? themeObj.fontSizeXs : "",
                  marginBottom: inputFocused || value.length > 0 ? "" : themeObj.spacingUnit,
                  opacity: "0.6"
                }
              })
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
                name: "arrow-down",
                size: 10
              }),
              className: "self-center absolute pointer-events-none",
              style: {
                color: themeObj.colorText,
                left: localeString.localeDirection === "rtl" ? "1%" : "97%",
                marginLeft: localeString.localeDirection === "rtl" ? "1rem" : "-1rem",
                opacity: __disabled_value ? "35%" : "",
                top: "42%"
              }
            })
          ],
          className: "relative"
        })
      ],
      className: `flex flex-col ` + __width_value
    })
  });
}

let make = DropdownField;

export {
  updateArrayOfStringToOptionsTypeArrayWithUpperCaseLabel,
  updateArrayOfStringToOptionsTypeArray,
  defaultValue,
  make,
}
/* jotai Not a pure module */
